import * as moment from 'moment';

import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ChargingSessionsService } from 'src/app/services/charging-sessions/charging-sessions.service';
import { ConstantService } from 'src/app/services/constant/constant.service';
import { CustomStorageService } from 'src/app/services/custom-storage/custom-storage.service';
import { DataTable } from '@pascalhonegger/ng-datatable';
import { DatePipe } from '@angular/common';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
})
export class UsersListComponent implements OnInit {
  @ViewChild('dataTable') dataTable: DataTable;

  responsive = true;
  employeesCustomer: any = [];
  loadingSpinner = false;
  loadingSpinnerSessions: boolean;
  enterprise;
  itemsPerPage = '5';
  searchTextEmail: any;
  searchTextUsername: any;
  searchTextNom: any;
  searchText;
  tableDataExcel: any = [];
  chargingLimits = [];
  excel = [];
  getFiltersForm: UntypedFormGroup;
  customersFilter = [];
  noDataFound = true;
  noDataFoundSessions = true;
  noDataSearch = false;
  questions: any[];
  excelArray: {};
  chargingSessions;
  paramsUser;

  displayDetailsModal: boolean;
  displayDeleteModal: boolean;
  displaySessionsModal: boolean;
  displayAnonymModal: boolean;
  loadingSpinnerModal = false;
  user;

  constructor(
    private readonly constantService: ConstantService,
    private readonly authService: AuthService,
    private readonly translate: TranslateService,
    private readonly datepipe: DatePipe,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly enterpriseService: EnterpriseService,
    private readonly chargingSessionsService: ChargingSessionsService,
    private readonly storageService: CustomStorageService,
    private readonly activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.initializeFilters();
    this.loadData();
    this.activatedRoute.queryParams
    .subscribe((params) => {
     if (params) {
      this.paramsUser = params['id'];
     }
    }
  );
  }

  initializeFilters() {
    this.getFiltersForm = this.formBuilder.group({
      searchTextUsername: this.searchTextUsername,
      searchTextEmail: this.searchTextEmail,
      searchTextNom: this.searchTextNom,
    });
  }

  /**
   * function is called to get list users with type employees.
   */
  loadData() {
    this.searchTextEmail =
      this.getFiltersForm.controls.searchTextEmail.setValue('');
    this.searchTextUsername =
      this.getFiltersForm.controls.searchTextUsername.setValue('');
    this.searchTextNom =
      this.getFiltersForm.controls.searchTextNom.setValue('');
    this.loadingSpinner = true;
    this.noDataFound = true;
    this.enterprise = this.storageService.getEnterprise();
    this.enterpriseService.getEmployees().subscribe(
      (data: any) => {
        if (data.users.length > 0) {
          this.employeesCustomer = data.users
            .filter(
              (x) =>
                (x.type === 'EnterpriseMember' || x.type === 'Member' ||
                  x.type === 'EnterpriseOfficer' ) && (
                x.isAnonymous === false ) && ( x.isDeleted === false )
            )
            .map((x) => ({
                email: x.email,
                username: x.username,
                firstName: x.firstName,
                lastName: x.lastName,
                fullName:
                  x.firstName && x.lastName
                    ? x.firstName + ' ' + x.lastName
                    : '--',
                gender: this.translate.instant(x.gender ? x.gender : 'male'),
                phoneNumber: x.phoneNumber,
                birthdate: x.birthdate,
                address: x.address,
                photo: x.photo,
                _id: x.id,
                type: this.translate.instant(x.type),
              }));
          if (this.employeesCustomer.length === 0) {
            this.noDataFound = true;
          } else {
            this.noDataFound = false;
          }
          this.customersFilter = this.employeesCustomer;
          this.searchDataByLink();
          // data download for file excel
          this.saveDataExcel();
          this.loadingSpinner = false;
          this.chargingLimits = data.users.map((employee) =>
            Math.floor(Math.random() * 100)
          );

        }
      },
      (error) => {
        if (error.status === 401) {
          this.authService.logout();
        }
      }
    );
  }

  /**
   * search Data from other route By Link
   */
  searchDataByLink() {
    if(this.paramsUser){
      this.employeesCustomer = this.customersFilter.filter((employee) => employee.username=== this.paramsUser);
      this.getFiltersForm.controls.searchTextUsername.setValue(this.paramsUser) ;
      this.employeesCustomer.length > 0
      ? (this.noDataSearch = false)
      : (this.noDataSearch = true);
  }

  }
  /**
   * Save the data in the excel array
   */
   saveDataExcel() {
    this.tableDataExcel = this.employeesCustomer
    .map((x) => ({
        Username: x.username,
        Email: x.email,
        Name: x.fullName
      }));
    this.excel = this.constantService.translateKeys(this.tableDataExcel);
  }

  /**
   * Multi search function on users table
   */
  onFilterChange() {
    this.searchTextEmail = this.getFiltersForm.controls.searchTextEmail.value;
    this.searchTextUsername =
      this.getFiltersForm.controls.searchTextUsername.value;
    this.searchTextNom = this.getFiltersForm.controls.searchTextNom.value;

    this.employeesCustomer = this.customersFilter.filter((employee) => {
      let isPassed = true;
      if (this.searchTextEmail && this.searchTextEmail !== '') {
        employee.email = employee.email.toString().trim().toLowerCase();
        this.searchTextEmail = this.searchTextEmail.trim().toLowerCase();
        isPassed =
          isPassed && employee.email.indexOf(this.searchTextEmail) > -1;
      }

      if (this.searchTextUsername && this.searchTextUsername !== '') {
        employee.username = employee.username.toString().trim().toLowerCase();
        this.searchTextUsername = this.searchTextUsername.trim().toLowerCase();
        isPassed =
          isPassed && employee.username.indexOf(this.searchTextUsername) > -1;
      }

      if (this.searchTextNom && this.searchTextNom !== '') {
        employee.fullName = employee.fullName.toString().trim().toLowerCase();
        this.searchTextNom = this.searchTextNom.trim().toLowerCase();
        isPassed =
          isPassed && employee.fullName.indexOf(this.searchTextNom) > -1;
      }

      return isPassed;
    });
    this.saveDataExcel();
    this.employeesCustomer.length > 0
      ? (this.noDataSearch = false)
      : (this.noDataSearch = true);
  }

  paginateChange(event) {
    this.dataTable.setPage(1, this.dataTable.rowsOnPage);
  }

  /**
   * Function is called to open modal contact.
   */
  openDialog(data, action) {
    this.user = data ;
    if (action === 'details') {
      this.displayDetailsModal = true;
    } else if (action === 'delete') {
      this.displayDeleteModal = true;
    } else if (action === 'anonym') {
      this.displayAnonymModal = true;
    } else if (action === 'sessions') {
      this.displaySessionsModal = true;
      this.loadingSpinnerSessions = true;
      this.chargingSessionsService.getSessionsByUser(this.user._id).subscribe(
        async (data: any) => {
        this.loadingSpinnerSessions = false;
          if (data.count === 0) {
            this.noDataFoundSessions = true ;
          } else {
            this.noDataFoundSessions = false;
            this.chargingSessions = data.data.filter((x) => ( x.status === 'COMPLETED') || ( x.status === 'ACTIVE')).map(row => ({
                authId: row.auth_id ? row.auth_id : '--',
                rfid: row.badge.rfid ? row.badge.rfid : '--',
                energyConsumed: row.kwh ? row.kwh : '--',
                duration: this.durationCalculation(row.start_datetime, row.end_datetime),
                cost: row.emspTotalCost ? row.emspTotalCost.toFixed(2) : '--',
                startDate: row.start_datetime ? this.datepipe.transform(row.start_datetime, 'yyyy-MM-dd HH:mm') : '--',
                endDate: row.last_updated ? row.last_updated : '--',
                id: row.id ? row.id : '--',
                location: row.location ? row.location : '--',
                cpoTariffCoef: row.fees.cpoTariffCoef ? row.fees.cpoTariffCoef : '--',
                intermediationFees: row.fees.intermediationFees ? row.fees.intermediationFees : '--',
                operatingFees: row.fees.operatingFees ? row.fees.operatingFees : '--',
                status: row.status ? row.status : '--',
                statusTr: row.status ? this.translate.instant(row.status) : '--'
              }));
          }
        },
        (error) => {
          this.loadingSpinnerSessions = false;
          switch (error.status) {
            case 409:
              this.constantService.showInfoToast('toast.error_incorrectDataSession');
              break;
            case 401:
              this.authService.logout();
              break;
            default:
              this.constantService.showErrorToast('toast.error_server');
              break;
          }
        }
      );
    }
  }

  /**
   * function is called to show user.
   */
  deleteUser() {
    this.loadingSpinner = true;
    const user = this.enterpriseService.deleteEmployee(this.user._id).subscribe(
      (res) => {
        this.loadingSpinner = false;
        this.loadData();
        this.constantService.showSuccessToast('toast.user_delete_success');
      },
      (error) => {
        this.loadingSpinner = false;
        this.constantService.showErrorToast('toast.user_delete_fail');
      }
    );
  }

  /**
   * function is called to make user anonym.
   */
  anonymEmployee() {
    this.loadingSpinner = true;
    // function service in enterprise.service
    const user = this.enterpriseService.anonymEmployee(this.user._id).subscribe(
      (res) => {
        this.loadData();
        this.constantService.showSuccessToast('toast.user_anonym_success');
        this.constantService.navigateToUsers('/anonymous');
      },
      (error) => {
        this.loadingSpinner = false;
        this.constantService.showErrorToast('toast.user_anonym_fail');
      }
    );
  }

  /**
   * function is called to download excel.
   */
  exportAsXLSX(): void {
    this.constantService.exportAsXLSX(this.excel, 'pages_titles.users.list');
  }

  /**
   * function is called to redirect to interface edit employees.
   */
  navigateEdit(id) {
    this.constantService.navigateToUsers('/edit', id);
  }

  /**
   * function is called to redirect to interface users add.
   */
  goAddEmployee() {
    this.constantService.navigateToUsers('/add-user');
  }

  /**
   * Calculation duration based on start date and end Date
   */
  durationCalculation(startDate, endDate) {
    const startTime = moment(startDate).format();
    const endTime = moment(endDate).format();
    const duration = moment.duration(moment(endTime).diff(startTime));
    const hoursMS = Math.abs(duration.get('hours')) + ':' + Math.abs(duration.get('minutes')) + ':' + Math.abs(duration.get('seconds'));
    return hoursMS;
  }
}
